<template>
    <section class="description">
        <editor v-if="isEditing" data-locator="editor" v-model="form.description" name="description"/>
        <div v-else class="description__body">
            <div data-locator="description" v-html="richDescription" />
            <div class="description__demo" v-if="job.is_demo">
                This is a demo job. <a href="#" @click="removeDemoJobs">Remove all demo jobs</a>
            </div>
        </div>

        <footer v-if="isMobile === false" class="description__footer">
            <span v-if="job.description_updated_at" data-locator="edited" class="description__timestamp">Last Edited: {{ job.description_updated_at }}</span>
            <template v-if="wasRequestedByCurrentUser">
                <template v-if="isEditing">
                    <button @click="cancel" :disabled="isBusy" data-locator="cancel" class="button button--small button--outline">Cancel</button>
                    <button @click="save" :disabled="isBusy" data-locator="save" class="button button--small button--primary">Save</button>
                </template>
                <button v-else @click="edit" data-locator="edit" class="button button--small button--primary">Edit</button>
            </template>
        </footer>
    </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Device from '../../mixins/deviceAware'
import Form from '../../helpers/Form'
import Editor from '../Global/Editor'
import MentionRender from '../../helpers/MentionRender'

export default {
    name: 'Description',

    mixins: [Device],

    data () {
        return {
            isEditing: false,
            isBusy: false,
            form: new Form({
                description: ''
            })
        }
    },

    methods: {
        edit () {
            this.form.description = this.richDescription
            this.isEditing = true
        },

        save () {
            if (this.isBusy) {
                return
            }

            this.isBusy = true

            this.$store.dispatch('job/saveDescription', this.form).then(() => {
                this.cancel()
                this.isBusy = false
            }).catch(() => {
                this.isBusy = false
            })
        },

        removeDemoJobs () {
            this.$store.dispatch('removeDemoJobs').then(() => {
                window.location.href = this.channel.url
            })
        },

        cancel () {
            this.isEditing = false
        }
    },

    computed: {
        ...mapState('users', ['current']),
        ...mapState('job', ['job']),
        ...mapState('channel', ['channel']),
        ...mapGetters('channel', ['activeMembers']),

        wasRequestedByCurrentUser () {
            return this.current.id === this.job.requester_id
        },

        richDescription () {
            let mentionRender = new MentionRender(this.activeMembers)

            return mentionRender.replaceMentions(this.job.description || '')
        }
    },

    components: {
        Editor
    }
}
</script>
